/* Recorte automatico del fondo blanco en el carrusel de la portada.
   ------------------------------------------------------------------
   Por que existe: las fotos del proveedor vienen con fondo blanco. El
   respaldo anterior era mix-blend-mode:multiply, pero NO sirve en la foto
   del centro: esa tarjeta lleva filter:drop-shadow y un filtro crea un
   contexto aislado, asi que la fusion no tiene fondo contra el cual
   mezclarse y el blanco se queda tal cual.

   Aqui se borra de verdad: se rellena desde las orillas hacia adentro
   quitando lo blanco, y se deja el resto intacto. Al partir de las orillas,
   el blanco que esta DENTRO del tacho (una franja, un logo) se respeta.

   OJO CON LA COLA (bug del 23-ago-2026): la primera version encadenaba las
   fotos una tras otra usando requestIdleCallback. En esta pagina ese callback
   NUNCA dispara (medido en vivo), asi que despues de la primera foto la
   cadena se moria y las demas se quedaban con su cuadro blanco. Ahora cada
   foto va por su cuenta: si una falla o tarda, no bloquea a las otras. */
(function () {
  var fotos = [].slice.call(document.querySelectorAll('img.cx__cuadro'));

  var SEMILLA = 236;  // que tan claro debe ser un pixel de la orilla para arrancar
  var EXPANDE = 228;  // y para seguir comiendo hacia adentro
  var SUAVE   = 205;  // debajo de esto ya es tacho: no se toca

  function recortar(img) {
    if (!img.naturalWidth) return;
    var an = img.naturalWidth, al = img.naturalHeight;
    if (an * al > 3200000) return;               // demasiado grande, no vale la pena

    var c = document.createElement('canvas');
    c.width = an; c.height = al;
    var g = c.getContext('2d', { willReadFrequently: true });
    var datos;
    try {
      g.drawImage(img, 0, 0);
      datos = g.getImageData(0, 0, an, al);
    } catch (e) { return; }                      // el CDN no dejo leer el lienzo

    var d = datos.data, total = an * al;
    var visto = new Uint8Array(total);
    var pila = [];

    function claridad(i) {
      var p = i * 4;
      return Math.min(d[p], d[p + 1], d[p + 2]);
    }
    function sembrar(i) {
      if (visto[i]) return;
      if (claridad(i) < SEMILLA) return;
      visto[i] = 1; pila.push(i);
    }

    for (var x = 0; x < an; x++) { sembrar(x); sembrar((al - 1) * an + x); }
    for (var y = 0; y < al; y++) { sembrar(y * an); sembrar(y * an + an - 1); }
    if (!pila.length) return;                    // la foto no traia marco blanco

    var borrados = 0;
    while (pila.length) {
      var i = pila.pop();
      d[i * 4 + 3] = 0;
      borrados++;
      var px = i % an, py = (i / an) | 0;
      var vecinos = [
        px > 0 ? i - 1 : -1,
        px < an - 1 ? i + 1 : -1,
        py > 0 ? i - an : -1,
        py < al - 1 ? i + an : -1
      ];
      for (var k = 0; k < 4; k++) {
        var j = vecinos[k];
        if (j < 0 || visto[j]) continue;
        var cl = claridad(j);
        if (cl >= EXPANDE) { visto[j] = 1; pila.push(j); }
        else if (cl >= SUAVE) {                  // orilla: se difumina, no se corta en seco
          visto[j] = 1;
          d[j * 4 + 3] = Math.round(255 * (EXPANDE - cl) / (EXPANDE - SUAVE));
        }
      }
    }
    if (borrados < total * 0.05) return;         // apenas quito nada: mejor dejarla como estaba

    g.putImageData(datos, 0, 0);
    var url;
    try { url = c.toDataURL('image/png'); } catch (e) { return; }
    img.src = url;
    img.classList.remove('cx__cuadro');          // ya no necesita el multiply
  }

  /* Lo llama el carrusel (6-sep-2026). La segunda foto de cada par -la del
     cambio al pasar el cursor- no existe cuando corre la tanda de abajo: se
     descarga hasta que hace falta, y solo en aparatos con puntero. Sin esta
     puerta se quedaria con su cuadro blanco encima del fondo de color. */
  window.xcRecorte = function (img) { try { recortar(img); } catch (e) {} };

  if (!fotos.length) return;

  /* Cada foto independiente. El escalon de 140ms es solo para no trabarse
     todas al mismo tiempo; si una tarda, las demas siguen su camino. */
  fotos.forEach(function (img, idx) {
    var hecho = false;
    function intentar() {
      if (hecho) return;
      hecho = true;
      setTimeout(function () {
        try { recortar(img); } catch (e) {}
      }, idx * 140);
    }
    if (img.complete && img.naturalWidth) intentar();
    else img.addEventListener('load', intentar, { once: true });
  });
})();
